class SecureFireFormAddEditModel {
    constructor(secureFireFormAddEditModel?: SecureFireFormAddEditModel) {
        this.createdUserId = secureFireFormAddEditModel?.createdUserId ? secureFireFormAddEditModel?.createdUserId : '';
        this.customerInformationDTO = secureFireFormAddEditModel?.customerInformationDTO ? secureFireFormAddEditModel?.customerInformationDTO : {};
        this.addressInfo = secureFireFormAddEditModel?.addressInfo ? secureFireFormAddEditModel?.addressInfo : {};
        this.afrigisAddressInfo = secureFireFormAddEditModel?.afrigisAddressInfo ? secureFireFormAddEditModel?.afrigisAddressInfo : {};

    }
    createdUserId: string;
    customerInformationDTO: CustomerInformationDTOModel | any;
    addressInfo: AddressInfoModel | any;
    afrigisAddressInfo: AfrigisAddressInfoModel | any;
}

class CustomerInformationDTOModel {
    constructor(customerInformationDTOModel?: CustomerInformationDTOModel) {
        this.customerTypeId = customerInformationDTOModel?.customerTypeId ? customerInformationDTOModel?.customerTypeId : '';
        this.titleId = customerInformationDTOModel?.titleId ? customerInformationDTOModel?.titleId : null;
        this.firstName = customerInformationDTOModel?.firstName ? customerInformationDTOModel?.firstName : '';
        this.lastName = customerInformationDTOModel?.lastName ? customerInformationDTOModel?.lastName : '';
        this.said = customerInformationDTOModel?.said ? customerInformationDTOModel?.said : '';
        this.companyName = customerInformationDTOModel?.companyName ? customerInformationDTOModel?.companyName : '';
        this.registerNumber = customerInformationDTOModel?.registerNumber ? customerInformationDTOModel?.registerNumber : '';
        this.mobile1 = customerInformationDTOModel?.mobile1 ? customerInformationDTOModel?.mobile1 : '';
        this.mobile2 = customerInformationDTOModel?.mobile2 ? customerInformationDTOModel?.mobile2 : '';
        this.officeNo = customerInformationDTOModel?.officeNo ? customerInformationDTOModel?.officeNo : '';
        this.premisesNo = customerInformationDTOModel?.premisesNo ? customerInformationDTOModel?.premisesNo : '';
        this.mobile1CountryCode = customerInformationDTOModel?.mobile1CountryCode ? customerInformationDTOModel?.mobile1CountryCode : '+27';
        this.mobile2CountryCode = customerInformationDTOModel?.mobile2CountryCode ? customerInformationDTOModel?.mobile2CountryCode : '+27';
        this.officeNoCountryCode = customerInformationDTOModel?.officeNoCountryCode ? customerInformationDTOModel?.officeNoCountryCode : '+27';
        this.premisesNoCountryCode = customerInformationDTOModel?.premisesNoCountryCode ? customerInformationDTOModel?.premisesNoCountryCode : '+27';
        this.email = customerInformationDTOModel?.email ? customerInformationDTOModel?.email : '';
        this.customerContactId = customerInformationDTOModel?.customerContactId ? customerInformationDTOModel?.customerContactId : '';
        this.contactId = customerInformationDTOModel?.contactId ? customerInformationDTOModel?.contactId : '';
        this.siteTypeId = customerInformationDTOModel?.siteTypeId ? customerInformationDTOModel?.siteTypeId : null;
        this.addressId = customerInformationDTOModel?.addressId ? customerInformationDTOModel?.addressId : '';
        this.customerId = customerInformationDTOModel?.customerId ? customerInformationDTOModel?.customerId : '';
    }
    customerTypeId?: string;
    titleId?: string | null;
    firstName?: string;
    lastName?: string;
    said?: string;
    companyName?: string;
    registerNumber?: string;
    mobile1?: string;
    mobile2?: string;
    officeNo?: string;
    premisesNo?: string;
    mobile1CountryCode?: string;
    mobile2CountryCode?: string;
    officeNoCountryCode?: string;
    premisesNoCountryCode?: string;
    email?: string;
    customerContactId?: string;
    contactId?: string;
    siteTypeId?: string | null;
    addressId?: string;
    customerId?: string;
}

class AddressInfoModel {
    constructor(addressInfoModel?: AddressInfoModel) {
        this.postalCode = addressInfoModel?.postalCode ? addressInfoModel?.postalCode : '';
        this.buildingNo = addressInfoModel?.buildingNo ? addressInfoModel?.buildingNo : '';
        this.buildingName = addressInfoModel?.buildingName ? addressInfoModel?.buildingName : '';
        this.streetName = addressInfoModel?.streetName ? addressInfoModel?.streetName : '';
        this.streetNo = addressInfoModel?.streetNo ? addressInfoModel?.streetNo : '';
        this.longitude = addressInfoModel?.longitude ? addressInfoModel?.longitude : '';
        this.latitude = addressInfoModel?.latitude ? addressInfoModel?.latitude : '';
        this.provinceName = addressInfoModel?.provinceName ? addressInfoModel?.provinceName : '';
        this.provinceId = addressInfoModel?.provinceId ? addressInfoModel?.provinceId : '';
        this.suburbName = addressInfoModel?.suburbName ? addressInfoModel?.suburbName : '';
        this.suburbId = addressInfoModel?.suburbId ? addressInfoModel?.suburbId : '';
        this.cityName = addressInfoModel?.cityName ? addressInfoModel?.cityName : '';
        this.cityId = addressInfoModel?.cityId ? addressInfoModel?.cityId : '';
        this.estateStreetNo = addressInfoModel?.estateStreetNo ? addressInfoModel?.estateStreetNo : '';
        this.estateStreetName = addressInfoModel?.estateStreetName ? addressInfoModel?.estateStreetName : '';
        this.estateName = addressInfoModel?.estateName ? addressInfoModel?.estateName : '';
        this.formatedAddress = addressInfoModel?.formatedAddress ? addressInfoModel?.formatedAddress : '';
        this.seoid = addressInfoModel?.seoid ? addressInfoModel?.seoid : '';
        this.addressConfidentLevelName = addressInfoModel?.addressConfidentLevelName ? addressInfoModel?.addressConfidentLevelName : '';
        this.addressConfidentLevelId = addressInfoModel?.addressConfidentLevelId ? addressInfoModel?.addressConfidentLevelId : '';
        this.latLong = addressInfoModel?.latLong ? addressInfoModel?.latLong : '';
        this.addressId = addressInfoModel?.addressId ? addressInfoModel?.addressId : '';
        this.isLSSScheme = addressInfoModel?.isLSSScheme ? addressInfoModel?.isLSSScheme : false;
        this.jsonObject = addressInfoModel?.jsonObject ? addressInfoModel?.jsonObject : '';
        this.isAddressComplex = addressInfoModel?.isAddressComplex ? addressInfoModel?.isAddressComplex : false;
        this.isAddressExtra = addressInfoModel?.isAddressExtra ? addressInfoModel?.isAddressExtra : false;
        this.isAfrigisSearch = addressInfoModel?.isAfrigisSearch ? addressInfoModel?.isAfrigisSearch : false;
        this.isNewAddress = addressInfoModel?.isNewAddress ? addressInfoModel?.isNewAddress : false;
        this.afriGISAddressId = addressInfoModel?.afriGISAddressId ? addressInfoModel?.afriGISAddressId : '';
    }
    postalCode?: string;
    buildingNo?: string;
    buildingName?: string;
    streetName?: string;
    streetNo?: string;
    longitude?: string;
    latitude?: string;
    provinceName?: string;
    provinceId?: string;
    suburbName?: string;
    suburbId?: string;
    cityName?: string;
    cityId?: string;
    estateStreetNo?: string;
    estateStreetName?: string;
    estateName?: string;
    formatedAddress?: string;
    seoid?: string;
    addressConfidentLevelName?: string;
    addressConfidentLevelId?: string;
    latLong?: string;
    addressId?: string;
    isLSSScheme?: boolean;
    jsonObject?: string;
    isAddressComplex?: boolean;
    isAddressExtra?: boolean;
    isAfrigisSearch?: boolean;
    isNewAddress?: boolean;
    afriGISAddressId?: string;
}

class AfrigisAddressInfoModel {
    constructor(afrigisAddressInfoModel?: AfrigisAddressInfoModel) {
        this.buildingName = afrigisAddressInfoModel?.buildingName ? afrigisAddressInfoModel?.buildingName : '';
        this.buildingNo = afrigisAddressInfoModel?.buildingNo ? afrigisAddressInfoModel?.buildingNo : '';
        this.streetNo = afrigisAddressInfoModel?.streetNo ? afrigisAddressInfoModel?.streetNo : '';
    }
    buildingName?: string;
    buildingNo?: string;
    streetNo?: string;
}

export { SecureFireFormAddEditModel, CustomerInformationDTOModel, AddressInfoModel, AfrigisAddressInfoModel }